export class SearchMerchandiseRequest{
    searchTerm: string = '';
    storeGuid?: string;
    constructor(searchTerm: string, storeGuid?: string) {
        this.searchTerm = searchTerm;
        if (storeGuid) {
            this.storeGuid = storeGuid;
        }
    }
}